import { call, put, takeLatest, select, delay } from 'redux-saga/effects';
import Strings, { PHONEPE_STATUS, PAYTM_STATUS } from '../constants/Strings';
import { get } from 'lodash';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { GET_NETBANKING_CONFIGURATIONS, GET_NETBANKING_CONFIGURATIONS_FAILURE, GET_NETBANKING_CONFIGURATIONS_SUCCESS, PAYMENT_USING_NETBANKING, PAYMENT_USING_NETBANKING_SUCCESS, PAYMENT_USING_NETBANKING_FAILURE, PAYMENT_USING_PHONEPE, PAYMENT_USING_PHONEPE_SUCCESS, PAYMENT_USING_PHONEPE_FAILURE, PHONEPE_STATUS_CHECK, PHONEPE_STATUS_CHECK_SUCCESS, PHONEPE_STATUS_CHECK_FAILURE, GET_PAYTM_TOKEN_SUCCESS, GET_PAYTM_TOKEN_FAILED, GET_PAYTM_TOKEN_CALL, PAYTM_STATUS_CHECK, PAYTM_STATUS_CHECK_SUCCESS, PAYTM_STATUS_CHECK_FAILURE, FETCH_OTHER_WALLETS_LIST, FETCH_OTHER_WALLETS_LIST_SUCCESS, FETCH_OTHER_WALLETS_LIST_FAILURE, PAYMENT_USING_GOOGLEPAY, PAYMENT_USING_GOOGLEPAY_SUCCESS, PAYMENT_USING_GOOGLEPAY_FAILURE, DELETE_SAVED_CARD, DELETE_SAVED_CARD_FAILURE, DELETE_SAVED_CARD_SUCCESS, PAYMENT_FOR_ADDHOPE, PAYMENT_FOR_ADDHOPE_SUCCESS, PAYMENT_FOR_ADDHOPE_FAILURE, PAYMENT_FOR_GIFTCARD, PAYMENT_FOR_GIFTCARD_FAILURE, PAYMENT_FOR_GIFTCARD_SUCCESS, GLOBALPAYMENTS_GENERATE_TOKEN, GLOBALPAYMENTS_GENERATE_TOKEND_SUCCESS, GLOBALPAYMENTS_GENERATE_TOKEND_FAILURE, GLOBALPAYMENTS_INITIATE_PAYMENT_CALL, GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_SUCCESS, GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_FAILED, GLOBALPAYMENTS_VALIDATE_ADDRESSS_SUCCESS, GLOBALPAYMENTS_VALIDATE_ADDRESSS_FAILURE, GLOBALPAYMENTS_VALIDATE_ADDRESSS, GLOBALPAYMENT_SAVE_CARD, GLOBALPAYMENT_SAVE_CARD_SUCCESS, GLOBALPAYMENT_SAVE_CARD_FAILUR, GLOBALPAYMENT_IS_STORE_3DS_ENABLED, GLOBALPAYMENT_IS_STORE_3DS_ENABLED_SUCCESS, GLOBALPAYMENT_IS_STORE_3DS_ENABLED_FAILURE, GLOBALPAYMENT_VERIFY_CARD, GLOBALPAYMENT_VERIFY_CARD_SUCCESS, GLOBALPAYMENT_VERIFY_CARD_FAILURE, } from '../constants';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import { resetCartReducer } from '../redux/Actions/CartAction';
const phoneStatusDelayInterval = 5000;
export function* getNetbankingConfigurationsCall(request) {
    try {
        const { payload } = request;
        const { tenantId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, get(networkConfig, Strings.allowedBanksForNetBanking), {}, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: GET_NETBANKING_CONFIGURATIONS_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: GET_NETBANKING_CONFIGURATIONS_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_NETBANKING_CONFIGURATIONS_FAILURE,
        });
    }
}
export function* getNetbankingConfigurationsSaga() {
    yield takeLatest(GET_NETBANKING_CONFIGURATIONS, getNetbankingConfigurationsCall);
}
export function* payUsingNetbankingCall(request) {
    try {
        const { payload } = request;
        const { tenantId, customerId, siteOrigin = '' } = payload;
        const { data } = payload;
        const { paymentProvider = '' } = data;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
            'x-site-origin': siteOrigin
        };
        const { response, status } = yield call(invokeApi, get(networkConfig, [paymentProvider, Strings.transactionRequest]), null, headers, data);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: PAYMENT_USING_NETBANKING_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: PAYMENT_USING_NETBANKING_FAILURE,
            });
            yield put(resetCartReducer());
        }
    }
    catch (error) {
        yield put({
            type: PAYMENT_USING_NETBANKING_FAILURE,
        });
        yield put(resetCartReducer());
    }
}
export function* payUsingNetbankingSaga() {
    yield takeLatest(PAYMENT_USING_NETBANKING, payUsingNetbankingCall);
}
export function* payUsingPaytmCall(request) {
    try {
        const { payload } = request;
        const { tenantId } = payload;
        const { data } = payload;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.paytmToken, null, headers, data);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        const isValidToken = response?.transactionId?.length > 0;
        if (isValidToken) {
            yield put({
                type: GET_PAYTM_TOKEN_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: GET_PAYTM_TOKEN_FAILED,
            });
            yield put(resetCartReducer());
        }
    }
    catch (error) {
        yield put({
            type: GET_PAYTM_TOKEN_FAILED,
        });
        yield put(resetCartReducer());
    }
}
export function* payUsingPaytmSaga() {
    yield takeLatest(GET_PAYTM_TOKEN_CALL, payUsingPaytmCall);
}
export function* payUsingPhonePe(request) {
    try {
        const { payload } = request;
        const { tenantId, data, customerId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.paymentForPhonePe, null, headers, data);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: PAYMENT_USING_PHONEPE_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: PAYMENT_USING_PHONEPE_FAILURE,
            });
            yield put(resetCartReducer());
        }
    }
    catch (error) {
        yield put({
            type: PAYMENT_USING_PHONEPE_FAILURE,
        });
        yield put(resetCartReducer());
    }
}
export function* payUsingPhonePeSaga() {
    yield takeLatest(PAYMENT_USING_PHONEPE, payUsingPhonePe);
}
export function* payUsingGooglePay(request) {
    try {
        const { payload } = request;
        const { tenantId, dataObj, customerId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.paymentForGooglePay, null, headers, dataObj);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: PAYMENT_USING_GOOGLEPAY_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: PAYMENT_USING_GOOGLEPAY_FAILURE,
            });
            yield put(resetCartReducer());
        }
    }
    catch (error) {
        yield put({
            type: PAYMENT_USING_GOOGLEPAY_FAILURE,
        });
        yield put(resetCartReducer());
    }
}
export function* payUsingGooglePaySaga() {
    yield takeLatest(PAYMENT_USING_GOOGLEPAY, payUsingGooglePay);
}
export function* fetchPhonePeStatus(request) {
    try {
        const { payload } = request;
        const { tenantId, transactionId, customerId } = payload;
        const phonePeStatusMaxCallsCount = yield select((state) => state.paymentsReducer.phonePeStatusMaxCallsCount);
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.phonePeStatus, { queryProps: { transactionId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response?.status) {
            if (phonePeStatusMaxCallsCount < 5) {
                if (response?.status === PHONEPE_STATUS.SUCCESS || response?.status === PHONEPE_STATUS.FAILURE) {
                    yield put({
                        type: PHONEPE_STATUS_CHECK_SUCCESS,
                        response,
                    });
                }
                else {
                    yield delay(phoneStatusDelayInterval);
                    yield put({
                        type: PHONEPE_STATUS_CHECK,
                        payload: request?.payload,
                        phonePeStatusMaxCallsCount: phonePeStatusMaxCallsCount + 1,
                    });
                }
            }
            else {
                yield put({
                    type: PHONEPE_STATUS_CHECK_FAILURE,
                    response,
                });
            }
        }
        else {
            yield put({
                type: PHONEPE_STATUS_CHECK_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: PHONEPE_STATUS_CHECK_FAILURE,
        });
    }
}
export function* checkPhonePeStatusSaga() {
    yield takeLatest(PHONEPE_STATUS_CHECK, fetchPhonePeStatus);
}
export const getPaytmStatusMaxCallsCount = (state) => state.paymentsReducer.paytmStatusMaxCallsCount;
export function* fetchPaytmStatus(request) {
    try {
        const { payload } = request;
        const { tenantId, transactionId, customerId } = payload;
        const paytmStatusMaxCallsCount = yield select(getPaytmStatusMaxCallsCount);
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.paytmStatus, { queryProps: { transactionId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response?.status) {
            if (paytmStatusMaxCallsCount < 10) {
                if (response?.status === PAYTM_STATUS.SUCCESS || response?.status === PAYTM_STATUS.FAILURE) {
                    yield put({
                        type: PAYTM_STATUS_CHECK_SUCCESS,
                        response,
                    });
                }
                else {
                    yield delay(phoneStatusDelayInterval);
                    yield put({
                        type: PAYTM_STATUS_CHECK,
                        payload: request?.payload,
                        paytmStatusMaxCallsCount: paytmStatusMaxCallsCount + 1,
                    });
                }
            }
            else {
                yield put({
                    type: PAYTM_STATUS_CHECK_FAILURE,
                    response,
                });
            }
        }
        else {
            yield put({
                type: PAYTM_STATUS_CHECK_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: PAYTM_STATUS_CHECK_FAILURE,
        });
    }
}
export function* checkPaytmStatusSaga() {
    yield takeLatest(PAYTM_STATUS_CHECK, fetchPaytmStatus);
}
export function* getAllowedWalletsList(request) {
    try {
        const { payload } = request;
        const { tenantId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.allowedWalletsForOtherWallets, {}, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: FETCH_OTHER_WALLETS_LIST_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: FETCH_OTHER_WALLETS_LIST_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: FETCH_OTHER_WALLETS_LIST_FAILURE,
        });
    }
}
export function* getAllowedWalletsListSaga() {
    yield takeLatest(FETCH_OTHER_WALLETS_LIST, getAllowedWalletsList);
}
export function* deleteSavedCard(request) {
    const { payload, successCallback = null } = request;
    const { customerId, cardId, tenantId } = payload;
    try {
        const response = yield call(invokeApi, networkConfig.deleteSavedCard, {
            queryProps: {
                customerId,
                cardId,
            },
        }, {
            'x-tenant-id': tenantId,
            'x-is-registered-user': 'true',
            'x-user-id': customerId,
        });
        if (response.status >= 400) {
            yield put(setErrorCode(response.status));
        }
        if (response.status === 200) {
            yield put({
                type: DELETE_SAVED_CARD_SUCCESS,
            });
            successCallback?.(response);
        }
    }
    catch (error) {
        yield put({
            type: DELETE_SAVED_CARD_FAILURE,
        });
    }
}
export function* deleteSavedCardSaga() {
    yield takeLatest(DELETE_SAVED_CARD, deleteSavedCard);
}
export function* paymentForAddHope(request) {
    try {
        const { payload } = request;
        const { tenantId } = payload;
        const { data } = payload;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.paymentForAddHope, null, headers, data);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (status === 200) {
            yield put({
                type: PAYMENT_FOR_ADDHOPE_SUCCESS,
                response,
            });
        }
    }
    catch (error) {
        yield put({
            type: PAYMENT_FOR_ADDHOPE_FAILURE,
        });
    }
}
export function* paymentForAddHopeSaga() {
    yield takeLatest(PAYMENT_FOR_ADDHOPE, paymentForAddHope);
}
export function* paymentForGiftCard(request) {
    try {
        const { payload } = request;
        const { tenantId } = payload;
        const { data } = payload;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.paymentForGifCard, null, headers, data, null, request);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (status === 200) {
            yield put({
                type: PAYMENT_FOR_GIFTCARD_SUCCESS,
                response,
            });
        }
    }
    catch (error) {
        yield put({
            type: PAYMENT_FOR_GIFTCARD_FAILURE,
        });
    }
}
export function* paymentForGiftCardSaga() {
    yield takeLatest(PAYMENT_FOR_GIFTCARD, paymentForGiftCard);
}
export function* gpGenerateToken(request) {
    const { payload, successCallback = null, errorCallback = null } = request;
    const { tenantId } = payload;
    const newNetwork = {
        ...networkConfig.globalPaymentsGenerateToken,
        ...payload,
    };
    try {
        const { response, status } = yield call(invokeApi, newNetwork, {}, {
            'x-tenant-id': tenantId,
        });
        if (status >= 400) {
            yield put(setErrorCode(status));
            errorCallback?.(response);
        }
        if (status === 200) {
            yield put({
                type: GLOBALPAYMENTS_GENERATE_TOKEND_SUCCESS,
                response,
            });
            successCallback?.(response);
        }
        else {
            yield put({
                type: GLOBALPAYMENTS_GENERATE_TOKEND_FAILURE,
            });
            errorCallback?.(response);
        }
    }
    catch (error) {
        yield put({
            type: GLOBALPAYMENTS_GENERATE_TOKEND_FAILURE,
        });
        errorCallback?.(error);
    }
}
export function* globalPaymentsGenerateTokenSaga() {
    yield takeLatest(GLOBALPAYMENTS_GENERATE_TOKEN, gpGenerateToken);
}
export function* gpInitiatePaymentCall(request) {
    const { payload, successCallback = null, errorCallback = null } = request;
    try {
        const { tenantId, data } = payload;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const newNetwork = {
            ...networkConfig.globalPaymentsInitiatePayment,
            ...payload,
        };
        const { response, status } = yield call(invokeApi, newNetwork, null, headers, data);
        if (status >= 400) {
            yield put(setErrorCode(status));
            errorCallback?.(response);
        }
        if (status == 200) {
            yield put({
                type: GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_SUCCESS,
                response,
            });
            successCallback?.(response);
        }
        else {
            yield put({
                type: GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_FAILED,
            });
            errorCallback?.(response);
        }
    }
    catch (error) {
        yield put({
            type: GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_FAILED,
        });
        errorCallback?.(error);
    }
}
export function* globalpaymentsInitiatePaymentSaga() {
    yield takeLatest(GLOBALPAYMENTS_INITIATE_PAYMENT_CALL, gpInitiatePaymentCall);
}
export function* gpAddressValidate(request) {
    const { payload, successCallback = null, errorCallback = null } = request;
    try {
        const { address } = payload;
        const headers = {
            'X-GP-Version': '2020-01-20',
        };
        const newNetwork = {
            ...networkConfig.gloablPaymentAddress,
            ...payload,
        };
        const { response, status } = yield call(invokeApi, newNetwork, null, headers, address);
        if (status >= 400) {
            yield put(setErrorCode(status));
            errorCallback?.(response);
        }
        if (status == 200) {
            yield put({
                type: GLOBALPAYMENTS_VALIDATE_ADDRESSS_SUCCESS,
                response,
            });
            successCallback?.(response);
        }
        else {
            yield put({
                type: GLOBALPAYMENTS_VALIDATE_ADDRESSS_FAILURE,
            });
            errorCallback?.(response);
        }
    }
    catch (error) {
        yield put({
            type: GLOBALPAYMENTS_VALIDATE_ADDRESSS_FAILURE,
        });
        errorCallback?.(error);
    }
}
export function* globalpaymentsAddressValidateSaga() {
    yield takeLatest(GLOBALPAYMENTS_VALIDATE_ADDRESSS, gpAddressValidate);
}
export function* gpSavecard(request) {
    const { payload, successCallback = null, errorCallback = null } = request;
    try {
        const { savecard, tenantId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const newNetwork = {
            ...networkConfig.gloablPaymentSaveCard,
            ...payload,
        };
        const { response, status } = yield call(invokeApi, newNetwork, null, headers, savecard);
        if (status >= 400) {
            yield put(setErrorCode(status));
            errorCallback?.(response);
        }
        if (status == 200) {
            yield put({
                type: GLOBALPAYMENT_SAVE_CARD_SUCCESS,
                response,
            });
            successCallback?.(response);
        }
        else {
            yield put({
                type: GLOBALPAYMENT_SAVE_CARD_FAILUR,
            });
            errorCallback?.(response);
        }
    }
    catch (error) {
        yield put({
            type: GLOBALPAYMENT_SAVE_CARD_FAILUR,
        });
        errorCallback?.(error);
    }
}
export function* gpSavecardSaga() {
    yield takeLatest(GLOBALPAYMENT_SAVE_CARD, gpSavecard);
}
export function* gpIsStore3dsEnabled(request) {
    const { payload, successCallback = null, errorCallback = null } = request;
    try {
        const { storeId, tenantId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const newNetwork = {
            ...networkConfig.gloablPaymentIsStore3dsEnabled,
            ...payload,
        };
        const { response, status } = yield call(invokeApi, newNetwork, { queryProps: { storeId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
            errorCallback?.(response);
        }
        if (status == 200) {
            yield put({
                type: GLOBALPAYMENT_IS_STORE_3DS_ENABLED_SUCCESS,
                response,
            });
            successCallback?.(response);
        }
        else {
            yield put({
                type: GLOBALPAYMENT_IS_STORE_3DS_ENABLED_FAILURE,
            });
            errorCallback?.(response);
        }
    }
    catch (error) {
        yield put({
            type: GLOBALPAYMENT_IS_STORE_3DS_ENABLED_FAILURE,
        });
        errorCallback?.(error);
    }
}
export function* gpIsStore3dsEnabledSaga() {
    yield takeLatest(GLOBALPAYMENT_IS_STORE_3DS_ENABLED, gpIsStore3dsEnabled);
}
export function* gpCardVerify(request) {
    const { payload, successCallback = null, errorCallback = null } = request;
    try {
        const { tenantId, cardDetails } = payload;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const newNetwork = {
            ...networkConfig.gloablPaymentVerifyCard,
            ...payload,
        };
        const { response, status } = yield call(invokeApi, newNetwork, null, headers, cardDetails);
        if (status >= 400) {
            yield put(setErrorCode(status));
            errorCallback?.(response);
        }
        if (status == 200) {
            yield put({
                type: GLOBALPAYMENT_VERIFY_CARD_SUCCESS,
                response,
            });
            successCallback?.(response);
        }
        else {
            yield put({
                type: GLOBALPAYMENT_VERIFY_CARD_FAILURE,
            });
            errorCallback?.(response);
        }
    }
    catch (error) {
        yield put({
            type: GLOBALPAYMENT_VERIFY_CARD_FAILURE,
        });
        errorCallback?.(error);
    }
}
export function* gpCardVerifySaga() {
    yield takeLatest(GLOBALPAYMENT_VERIFY_CARD, gpCardVerify);
}
